/**
 * Obfuscates a full name preserving initial letters and the last letter of each word.
 * Rules:
 * - Word length >= 4: first 2 characters + asterisks + last character (e.g., "Euler" -> "Eu**r", "Gutierres" -> "Gu******s")
 * - Word length == 3: first character + asterisk + last character (e.g., "Ana" -> "A*a", "rio" -> "r*o")
 * - Word length <= 2: first character + asterisk (e.g., "De" -> "D*")
 */
export function obfuscateName(fullName: string): string {
  if (!fullName) return "***";
  const trimmed = fullName.trim();
  if (trimmed.length === 0) return "***";

  const words = trimmed.split(/\s+/);
  const obfuscatedWords = words.map((word) => {
    const len = word.length;
    if (len >= 4) {
      const firstTwo = word.slice(0, 2);
      const lastOne = word.slice(-1);
      const asterisks = "*".repeat(len - 3);
      return `${firstTwo}${asterisks}${lastOne}`;
    }
    if (len === 3) {
      const firstOne = word.charAt(0);
      const lastOne = word.charAt(2);
      return `${firstOne}*${lastOne}`;
    }
    if (len === 2) {
      return `${word.charAt(0)}*`;
    }
    return word;
  });

  return obfuscatedWords.join(" ");
}

/**
 * Formats a clean 10-digit phone number with Colombia prefix without masking.
 * Example: "3178385056" -> "+57 317 838 5056"
 */
export function formatPhone(phone: string): string {
  if (!phone) return "";
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length === 10) {
    return `+57 ${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
  }
  return phone.startsWith("+") ? phone : `+57 ${phone}`;
}

